import { createContext, useContext } from 'react'

export const HostNavigationContext = createContext<(() => void) | null>(null)
export const useHostBack = () => useContext(HostNavigationContext)

/** Overlay entries share the route index, so they must be consumed first. */
export function hostBackAction(input: {
  overlayOpen: boolean
  drawerOpen: boolean
  hasStackBack: boolean
  isHome: boolean
  currentIndex: number
  entryIndex: number
}): 'overlay' | 'drawer' | 'stack' | 'history' | 'close' {
  if (input.overlayOpen) return 'overlay'
  if (input.drawerOpen) return 'drawer'
  if (input.hasStackBack) return 'stack'
  if (!input.isHome && input.currentIndex > input.entryIndex) return 'history'
  return 'close'
}
